import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { assembleName, generateLabel } from './util';

export interface ISubscriberBadgeProps {
    className?: string;
    id?: string;
    first?: string;
    last?: string;
    suffix?: string;
    path?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const SubscriberBadge: React.FunctionComponent<ISubscriberBadgeProps> = (
    props: ISubscriberBadgeProps,
): React.ReactElement => {
    const { className, id, first, last, suffix, path, tooltip, items } = props;
    const name = assembleName(first, last, suffix);
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Subscriber', id, name)}
            path={path || `/subscribers/${id}`}
            tooltip={tooltip}
            items={items}
            id={id}
        />
    );
};
